module.exports = {"pt-BR":{"echo":{"show":{"shout":"Tudo o que vai...","placeholder":"...volta!"}}}}